__turbopack_context__.v({
  "container": "mcvURq_container",
  "description": "mcvURq_description",
  "galleryWrapper": "mcvURq_galleryWrapper",
  "imageButtonReset": "mcvURq_imageButtonReset",
  "imageContainer": "mcvURq_imageContainer",
  "imageWrapper": "mcvURq_imageWrapper",
  "lightBoxWrapper": "mcvURq_lightBoxWrapper",
  "lightboxOverride": "mcvURq_lightboxOverride",
  "title": "mcvURq_title",
});
